// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"176c4e55","977":"20ec56f8"}[chunkId] + ".chunk.js";
};